import request from '@/utils/request'

/**
 * 任务日志列表
 */
export const getTaskList = (data) => {
    return request({
        url: '/task/lists',
        params: data
    })
}

/**
 * 任务选项列表
 */
export const getTaskOptionsList = () => {
    return request({
        url: '/task/option/lists'
    })
}

/**
 * 新增任务
 */
export const addTask = (data) => {
    return request({
        url: '/task/manage',
        method: 'POST',
        data
    })
}

/**
 * 任务-详情
 */
export const getTaskDetail = (id) => {
    return request({
        url: `/task/${id}`
    })
}

/**
 * 任务-编辑
 */
export const putTask = (data) => {
    return request({
        url: '/task/manage',
        method: 'PUT',
        data
    })
}

/**
 * 任务-删除
 */
export const delTask = (id) => {
    return request({
        url: `/task/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/task/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/task/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/task/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
